<form class="dynamic-form mb-0" [formGroup]="form" (ngSubmit)="onSubmit()">
    <ng-container *ngFor="let field of fields;" dynamicField  [readonly]="readonly" [field]="field" [group]="form" >
    </ng-container>
</form>
